import { render, staticRenderFns } from "./InvoiceUnpaid.vue?vue&type=template&id=b3d45dcc"
import script from "./InvoiceUnpaid.vue?vue&type=script&lang=js"
export * from "./InvoiceUnpaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports